const getCarePlanIdFromPath = (path) => {
  return path.split('/care_plans/').pop().split('/tasks/weekly').shift()
}

export default getCarePlanIdFromPath;
